module.exports = __webpack_public_path__ + "assets/img/14.f005ea53.png";